export default __webpack_public_path__ + "images/046cd0faff25963b40036c915cd75b26-visa@2x.png";